/*----------------------------------
- GENERATED FILE
----------------------------------*/

// This file is generated by Proteum from client/pages/marketing/api-recruitment.tsx.
// Do not edit it manually.

import type __GeneratedRouteApp from "@/client/index";

import React from 'react';


/*----------------------------------
- APP
----------------------------------*/

import RecruitmentApiDocumentationPage from '@/client/components/marketing/api/RecruitmentApiDocumentationPage';

/*----------------------------------
- ROUTE
----------------------------------*/

export const __register = (app: __GeneratedRouteApp) => {
  const { Router } = app;
  return Router.page('/api/recruitment', { ...({
    static: {
        refresh: '1h',
        urls: ['/api/recruitment'],
    },
}), ...{ filepath: "/app/client/pages/marketing/api-recruitment.tsx", sourceLocation: { line: 14, column: 1 }, id: "marketing_api_recruitment" } }, null, ({ request }) => {
    return <RecruitmentApiDocumentationPage currentOrigin={new URL(request.url).origin} />;
});
};
